export const SCREENING_USER_EMAIL_VERIFICATION_REQUEST = '/candidate-email-verification-request';
export const SCREENING_USER_REGISTRATION = '/candidate-registration';
export const APPLICANT_INFO_UPDATE = '/candidate-info-update';
export const APPLICANT_FILES = '/applicant-files';
export const CANDIDATES = '/candidates';
export const SHORT_LIST_CANDIDATE_POST = 'shortList-Candidate';
export const SHORT_LIST_CANDIDATES = 'shotListed-candidates';
export const CREATE_NEW_APPLICATION = '/create_new_application';
export const ADD_APPLICANT_COMMENT = '/screen-status';
export const GET_APPLICANT_DATA_BY_ID = '/applicant-data?id=';
export const GET_APPLICANT_DATA_BY_EMAIL = '/applicant-data?email=';
export const APPLICANT_SEARCH = '/applicant-search?applicant_id=';
export const SCREENING_SCHEDULE = '/screening-schedule';
export const COMPLETED_SCREENING = '/completed-screening';
export const VETTING = '/complete-screening';
export const SCREENING_CHECKLIST = '/screening-checklist';
export const CREDITS = '/credits';
export const AVAILABLE_CREDITS = '/available-credits';
export const PUBLIC_APPLICATION_LINK = '/public-application-form-link';

export const SCREENING_ENDORSEMENT_DETAIL = '/screening-endorsement/detail/';
export const SCREENING_ENDORSEMENT_UPDATE = '/screening-endorsement/update';

export const APPLICANT_SOCIAL_MEDIA_CHECK = '/applicant-social-media-check';
